<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>
    <Loader v-if="loading" />
    <div v-else-if="data.chapter.id" class="card shadow p-5">
      <h3 class="mb-3 text-center">
        {{ data.chapter.name }}
        <abbr
          v-if="data.chapter.is_final"
          title="Эта глава - финальная, будет доступна после завершения всех остальных"
          class="badge badge-info"
          >fin</abbr
        >
      </h3>
      <p class="mb-5 text-center">
        <strong>Состояние Главы: </strong>
        <span
          v-bind:class="{
            'text-success': data.chapterstate.id == 5,
            'text-muted': data.chapterstate.id == 1,
          }"
          style="font-weight: bold"
          >{{ data.chapterstate.name }}</span
        >
      </p>

      <div class="mb-3"><strong>Введение:</strong></div>
      <p
        class="bg-light  p-3 mb-5 bg-white rounded"
        v-html="brFunc(data.chapter.description)"
      ></p>

      <p class="mb-3"><strong>Текст:</strong></p>
      <p
        class="bg-light p-3 mb-5 bg-white rounded"
        v-html="data.chapter.text"
      ></p>
      <!-- <p>{{data.chapter.text}}</p> -->

      <div class="alert alert-danger" v-if="errors.any">
        {{ errors.any }}
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "", validation: "" },
      title: "Просмотр Главы",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/chapters/" + this.$route.params.id + "/show"
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.load = e.response.data.error;
        } else if (e.response.status == 401) {
          this.errors.load = e.response.data.error;
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },
  },
  components: {
    Loader,
    PageTitle,
    BreadCrumbs,
  },
};
</script>